var map = {
	"./0iconmonstr-paintbrush-7.svg": 144,
	"./1bluebed.png": 4459,
	"./2redbed.png": 2948,
	"./3greenbed.png": 7590,
	"./4goldbed.png": 8271,
	"./5graybed.png": 4423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 834;